import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import { links } from '[theme-lib]/links';

import { reportButtonClick } from '../utils';

import basketModes from 'apps/basket/utils/basketModes';

import { priceFormat } from 'lib/apps/products/utils/priceFormat';

import TrolleyItemsPageComponents from 'apps/header/analytics/containers/TrolleyItemsPageComponents';
import MiniTrolleyItem from 'apps/header/containers/MiniTrolleyItem';

export default class MiniBasket extends PureComponent {
  static propTypes = {
    basket: PropTypes.shape({
      checkoutAllowed: PropTypes.bool.isRequired,
      items: PropTypes.array.isRequired,
      numberOfItems: PropTypes.number.isRequired,
      minimumOrderValue: PropTypes.number.isRequired,
      mode: PropTypes.oneOf(Object.values(basketModes)).isRequired,
    }).isRequired,
    deliverySlot: PropTypes.object,
    displayWarning: PropTypes.func.isRequired,
    ensureBasketProducts: PropTypes.func.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    props.ensureBasketProducts();
  }

  renderTrolleyItems = () => {
    const { basket } = this.props;

    if (!basket.numberOfItems) {
      return (
        <>
          <TrolleyItemsPageComponents items={basket.items} />
          <div className="hd-miniTrolley__emptyInformation">
            Your trolley is empty
          </div>
        </>
      );
    }

    return (
      <>
        <TrolleyItemsPageComponents items={basket.items} />
        <div className="hd-miniTrolley__itemsContainer">
          <ul className="hd-miniTrolley__items">
            {basket.items.map((item) => (
              <MiniTrolleyItem
                basketItem={item}
                key={item.sku}
                sku={item.sku}
                shouldTrimProductName={false}
                shouldShowTotalPrice
              />
            ))}
          </ul>
        </div>
      </>
    );
  };

  onLinkClick = (description, pathname, isCheckoutBtn = false) => (e) => {
    const { basket, router } = this.props;
    e.preventDefault();

    if (!isCheckoutBtn || basket.checkoutAllowed) {
      const redirect = () => router.push({ pathname });
      reportButtonClick(description, 'DESKTOP_HEADER', redirect);
    }
  }

  onCancelButtonClick = () => {
    const { displayWarning } = this.props;
    reportButtonClick('Cancel Changes button clicked', 'DESKTOP_HEADER', displayWarning);
  }

  render() {
    const { basket, deliverySlot } = this.props;
    const isEditing = basket.mode === basketModes.EDIT || basket.mode === basketModes.REORDER;
    const checkoutClassNames = classNames(
      'hd-miniTrolley__bottomBtn',
      'hd-miniTrolley__bottomBtn--checkout',
      { 'hd-miniTrolley__bottomBtn--disabled': !basket.checkoutAllowed }
    );

    return (
      <div className="hd-miniTrolley">
        { this.renderTrolleyItems() }
        <div className="hd-miniTrolley__bottom">
          {!deliverySlot && (
            <Link
              to={links.BOOK_DELIVERY}
              onClick={this.onLinkClick(
                'Book Delivery button clicked',
                links.BOOK_DELIVERY,
              )}
              className="hd-miniTrolley__bottomBtn hd-miniTrolley__bottomBtn--delivery"
            >
              Book a delivery
            </Link>
          )}
          {isEditing && (
            <button
              onClick={this.onCancelButtonClick}
              className="hd-miniTrolley__bottomBtn hd-miniTrolley__bottomBtn--cancel"
            >
              Cancel changes
            </button>
          )}
          <Link
            to={links.DISPLAY_BASKET}
            onClick={this.onLinkClick(
              'View full trolley button clicked',
              links.DISPLAY_BASKET,
            )}
            className="hd-miniTrolley__bottomBtn hd-miniTrolley__bottomBtn--viewAll"
          >
            View full trolley
          </Link>
          {deliverySlot && (
            <Link
              to={links.CHECKOUT}
              onClick={this.onLinkClick(
                'Checkout button clicked',
                links.CHECKOUT,
                true,
              )}
              className={checkoutClassNames}
            >
              Checkout
              {!basket.checkoutAllowed && (
                <span className="hd-miniTrolley__minOrder">
                  Minimum spend of {
                    priceFormat({ value: basket.minimumOrderValue, zeroAfterPound: false, inPound: true })
                  }
                </span>
              )}
            </Link>
          )}
        </div>
      </div>
    );
  }
}
